import React from 'react';
import { motion } from 'framer-motion';
import { Star, MapPin } from 'lucide-react';
const testimonials = [{
  initials: 'CG',
  name: 'Camila G.',
  location: 'Buenos Aires, Argentina',
  role: 'Docente de Biología',
  quote: '"Lo que más me ayuda es tener los contenidos organizados por niveles. Puedo seleccionar las actividades que necesito y preparar mis clases con mayor claridad."',
  color: 'bg-blue-600'
}, {
  initials: 'DR',
  name: 'Daniela R.',
  location: 'Santiago, Chile',
  role: 'Profesora de Ciencias Naturales',
  quote: '"Las actividades secuenciadas y los recursos visuales me permiten explicar temas complejos de una manera más clara y dinámica."',
  color: 'bg-indigo-600'
}, {
  initials: 'AM',
  name: 'Andrés M.',
  location: 'Medellín, Colombia',
  role: 'Docente de educación secundaria',
  quote: '"Contar con evaluaciones y rúbricas listas me permite trabajar con criterios más claros y reducir el tiempo que dedico a preparar materiales."',
  color: 'bg-sky-600'
}, {
  initials: 'VP',
  name: 'Valeria P.',
  location: 'Lima, Perú',
  role: 'Profesora de Biología',
  quote: '"Puedo adaptar los contenidos al programa de mi institución y elegir las actividades más adecuadas para cada grupo de estudiantes."',
  color: 'bg-green-600'
}, {
  initials: 'MC',
  name: 'Mariela C.',
  location: 'La Paz, Bolivia',
  role: 'Docente de Ciencias Naturales',
  quote: '"Las propuestas de laboratorio de bajo costo y los proyectos me ayudan a desarrollar clases más participativas sin comenzar desde cero."',
  color: 'bg-slate-600'
}];
export function DetailedTestimonials() {
  return <section className="py-8 md:py-20 px-4 bg-sky-50" data-id="element-48">
      <div className="max-w-6xl mx-auto" data-id="element-49">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-slate-900 mb-6 md:mb-16" data-id="element-50">
          Lo que dicen los docentes
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-slate-600 font-medium text-sm md:text-lg text-center max-w-2xl mx-auto -mt-2 mb-6 md:-mt-10 md:mb-16" data-id="element-51">
          Experiencias representativas de cómo este material puede acompañar la
          planificación docente.
        </motion.p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-52">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 rounded-[2rem] shadow-xl shadow-blue-900/5 border border-blue-100 flex flex-col" data-id="element-53">
              <div className="flex gap-1 mb-4" data-id="element-54">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-emerald-600 text-emerald-600" data-id="element-55" />)}
              </div>

              <blockquote className="text-slate-800 font-bold text-sm md:text-lg leading-relaxed mb-8 flex-1 italic" data-id="element-56">
                {t.quote}
              </blockquote>

              <div className="flex items-center gap-4 pt-6 border-t border-slate-50" data-id="element-57">
                <div className={`${t.color} w-12 h-12 rounded-2xl flex items-center justify-center text-white font-black text-lg shadow-lg shrink-0`} data-id="element-58">
                  {t.initials}
                </div>
                <div data-id="element-59">
                  <p className="font-black text-slate-900 text-sm md:text-base" data-id="element-60">
                    {t.name}
                  </p>
                  <div className="flex items-center gap-1 text-slate-500 font-medium text-[10px] md:text-xs" data-id="element-61">
                    <MapPin size={12} data-id="element-62" />
                    <span data-id="element-63">
                      {t.location} | {t.role}
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}